import { getLangCode } from "./getLangCode";

const loadCustomOneDS = () =>{
    const langCode = getLangCode();
    if (langCode && langCode !== 'login') {
        const script =  document.createElement('script');
        script.type = 'text/javascript';
        if (process.env.REACT_APP_ANALYTICS_ENV === 'prod') {
            script.src = `https://cm-edgetun.pages.dev/${langCode}/isv/marketplace-app-advisor/scripts/customOneds.min.js`;
        }
        else if (process.env.REACT_APP_ANALYTICS_ENV === 'ppe') {
            script.src = `https://wwwppe.microsoft.com/${langCode}/isv/marketplace-app-advisor/scripts/customOneds.min.js`;
        } else {
            script.src = `https://isv-adv-dev-eastus-app.azurewebsites.net/${langCode}/isv/marketplace-app-advisor/scripts/customOneds.min.js`
        }
        document.head.appendChild(script);
    }
}

const onConsentChanged = (categoryPreferences) => {
    // below code is commented for loading analytics irrespective of consent actions.
    // const isAnalyticsConsented = categoryPreferences?.Analytics;
    // if(isAnalyticsConsented){
        // loadCustomOneDS();
    // }
}

export const setCookieConsentConfig = ()=>{
    const languageCode = getLangCode();
    window.WcpConsent && window.WcpConsent.init(languageCode, "msccBannerV2", function (err, _siteConsent) {
        if (!err) {
            // below code is commented for loading analytics irrespective of consent actions.
            // const isAnalytics = _siteConsent?.getConsent()?.Analytics;
            // if(isAnalytics){
                loadCustomOneDS();
            // }
        } else {
            console.error("Error initializing WcpConsent: "+ err);
        }
    }, onConsentChanged, window.WcpConsent.themes.light);
}